module.exports = __webpack_public_path__ + "static/media/learning-step1.6bf47d32.png";